import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d87c91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-normal" }
const _hoisted_2 = {
  key: 1,
  class: "form mb-48"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-4" }
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = { class: "col-4" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "col-4" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "d-flex justify-content-end mb-16" }
const _hoisted_47 = { class: "w-100 d-flex flex-row mb-16" }
const _hoisted_48 = { class: "position-relative" }
const _hoisted_49 = { class: "item fw-bold" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = { class: "item" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_53 = { class: "fw-normal" }
const _hoisted_54 = {
  key: 0,
  class: "form-group"
}
const _hoisted_55 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_form_group_read_only_text = _resolveComponent("v-form-group-read-only-text")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!
  const _component_the_admin_clinic_create_modal = _resolveComponent("the-admin-clinic-create-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_modal, {
      size: "xl",
      "class-name": "modal-fullscreen-lg-down",
      onClosed: _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_modal_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_modal_title, { as: "h4" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('Visualización de')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('profesional')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_modal_body, null, {
          default: _withCtx(() => [
            (_ctx.status === 'loading')
              ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("fieldset", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Tipo documento identidad'),
                          text: _ctx.identityDocType(),
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Nº documento identidad'),
                          text: _ctx.currentProfessional.nif,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Tipo de profesional'),
                          text: _ctx.parseRoleName(_ctx.currentProfessional.user.role),
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Nombre'),
                          text: _ctx.currentProfessional.name,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Apellidos'),
                          text: _ctx.currentProfessional.surname,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Género'),
                          text: _ctx.genre(),
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Correo'),
                          text: _ctx.currentProfessional.user.email,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Prefijo teléfono'),
                          text: _ctx.phoneNumberPrefix,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Nº teléfono'),
                          text: _ctx.phoneNumber,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Fecha de nacimiento'),
                          text: _ctx.$str.formatDate(_ctx.currentProfessional.bornDate),
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Dirección personal')), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Dirección 1'),
                          text: _ctx.currentProfessional.personalLine1,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Dirección 2'),
                          text: _ctx.currentProfessional.personalLine2,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Código postal'),
                          text: _ctx.currentProfessional.personalCP,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Ciudad'),
                          text: _ctx.currentProfessional.personalCity,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Provincia'),
                          text: _ctx.currentProfessional.personalProvince,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('País'),
                          text: _ctx.currentProfessional.personalCountry,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Dirección profesional')), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Dirección 1'),
                          text: _ctx.currentProfessional.professionalLine1,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Dirección 2'),
                          text: _ctx.currentProfessional.professionalLine2,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Código postal'),
                          text: _ctx.currentProfessional.professionalCP,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Ciudad'),
                          text: _ctx.currentProfessional.professionalCity,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Provincia'),
                          text: _ctx.currentProfessional.professionalProvince,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('País'),
                          text: _ctx.currentProfessional.professionalCountry,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_v_form_group_read_only_text, {
                        class: "mb-24",
                        label: _ctx.$t('¿Puede autorizar libremente?'),
                        text: _ctx.canFreelyAuthorize,
                        "bg-transparent": true
                      }, null, 8, ["label", "text"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_v_form_group_read_only_text, {
                        class: "mb-24",
                        label: _ctx.$t('Médico activo?'),
                        text: _ctx.isActive,
                        "bg-transparent": true
                      }, null, 8, ["label", "text"])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_33, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Personificación')), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("p", null, _toDisplayString(// eslint-disable-next-line max-len
                _ctx.$t('Puedes iniciar sesión como si fueses el profesional en cuestión para visualizar lo mismo que ve ese profesional y así poder comprobar errores que reporta, validar funcionalidades, etc. Entrarás a la plataforma como si hubieses iniciado sesión con sus credenciales. Ten cuidado porque los cambios que hagas también serán definitivos como si hubieran sido suyos.')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_v_button, {
                          variant: "primary",
                          onClick: _ctx.impersonate
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(// eslint-disable-next-line max-len
                  _ctx.$t('Iniciar sesión como el profesional {nombre_profesional}', { nombre_profesional: _ctx.currentProfessional.name + ' ' + _ctx.currentProfessional.surname})), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_37, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Especialidad')), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Principal'),
                          text: _ctx.currentProfessional.speciality,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Subespecialidad'),
                          text: _ctx.currentProfessional.subspeciality,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_41, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Colegiado')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Colegio'),
                          text: _ctx.currentProfessional.college,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_v_form_group_read_only_text, {
                          class: "mb-24",
                          label: _ctx.$t('Número de colegiado'),
                          text: _ctx.currentProfessional.collegeNumber,
                          "bg-transparent": true
                        }, null, 8, ["label", "text"])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_45, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Lugares de trabajo')), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_v_button, {
                        variant: "secondary",
                        "aria-label": _ctx.$t('Añadir nueva clínica'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-admin-clinic-create-modal'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Añadir nueva clínica')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_v_form_group_select, { class: "select me-16" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            options: _ctx.availableClinicsOptions,
                            label: "label",
                            reduce: returnValue => returnValue.key,
                            placeholder: _ctx.$t('Seleccciona un clínica'),
                            "select-on-key-codes": [188, 13],
                            modelValue: _ctx.selectedClinicId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClinicId) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["options", "reduce", "placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_button, {
                        variant: "secondary",
                        "aria-label": _ctx.$t('Asociar'),
                        onClick: _ctx.associateProfessionalWithClinic,
                        disabled: !_ctx.selectedClinicId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Asociar')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick", "disabled"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProfessional.clinics, (clinic) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "container-item d-flex justify-content-between align-items-center py-8 px-16",
                        key: clinic.id
                      }, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(clinic.name), 1),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(clinic.address), 1),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(clinic.phoneNumber.replace(' ', '')), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_button, {
                            variant: "icon",
                            class: "btn-sm justify-content-center d-flex flex-column p-0",
                            onClick: ($event: any) => (_ctx.disassociateProfessionalFromClinic(_ctx.currentProfessional.id, clinic.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_52,
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('Desasociar')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.currentProfessional.user?.phoneNumbers?.length > 0)
                    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_54, [
                        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Otros teléfonos')), 1),
                        _createElementVNode("div", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProfessional.user.phoneNumbers, (phone, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-6",
                              key: index
                            }, [
                              _createVNode(_component_v_form_group_read_only_text, {
                                label: _ctx.$t('Teléfono'),
                                text: phone
                              }, null, 8, ["label", "text"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_modal_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_button, {
              variant: "link-secondary",
              class: "me-24",
              "aria-label": _ctx.$t('Cancelar'),
              "data-bs-dismiss": "modal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClosed"]),
    (_ctx.modalToShow === 'the-admin-clinic-create-modal')
      ? (_openBlock(), _createBlock(_component_the_admin_clinic_create_modal, {
          key: 0,
          onRefreshClinics: _ctx.loadInitData,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = ''))
        }, null, 8, ["onRefreshClinics"]))
      : _createCommentVNode("", true)
  ], 64))
}